export default "__VITE_ASSET__c3a478ef__"